export default __webpack_public_path__ + "static/media/shyft-logo-grey.204594ad.svg";